const buildDirectional = (key: string[][], handlerNames: string[]) => {
  const result: Record<string, string> = {};
  key.forEach((directionSet) => {
    directionSet.forEach((key, index) => {
      result[key] = handlerNames[index];
    });
  });
  return result;
};

const UPPER_START = 65;
const UPPER_END = 90;
const buildAlphaNumeric = () => {
  const result: Record<string, string> = {};
  let ch, lower;
  for (let i = UPPER_START; i <= UPPER_END; i++) {
    ch = String.fromCharCode(i);
    result[ch] = ch;
    lower = ch.toLocaleLowerCase();
    result[lower] = ch;
  }
  return result;
};

export default {
  cancel: {
    Escape: "cancel",
    Backspace: "cancel",
  },
  advance: {
    Enter: "advance",
  },
  graphMovement: {
    ...buildDirectional(
      [["ArrowUp", "ArrowLeft", "ArrowDown", "ArrowRight"]],
      ["up", "left", "down", "right"]
    ),
    ...buildDirectional(
      [["SArrowUp", "SArrowLeft", "SArrowDown", "SArrowRight"]],
      ["sUp", "sLeft", "sDown", "sRight"]
    ),
  },
  letters: buildAlphaNumeric(),
  baseActions: {
    Backspace: "backspace",
    Delete: "backspace",
    " ": "swapDirection",
  },
  playerActions: {
    Tab: "spellList",
    "\\": "spellList",
    F9: "cheat",
    ".": "wait",
  },
} as const;
